import { developmentFlag } from "constants/common";

export const classnames = (...args) => {
  return args.join(" ");
};

export const getTimeString = (time) => {
  return new Date(time * 1000).toISOString().substring(14, 19) ?? "--:--"
};

export const getTimeInSeconds = (dateObj=null) => {
  if (!dateObj) return new Date().getTime()/1000;
  return new Date(dateObj).getTime()/1000;
};

export const getHoursAndMinutes = (dateSeconds) => {
  const date = new Date(dateSeconds * 1000);

  const options = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };

  return date.toLocaleString('en-US', options);
};

export const noAuthHeaders = {
  'Content-Type': 'application/json',
  'Unberry-NoAuth': "HfPzIPo78KzG8NoIt3kPA"
};

// Right-click, copy-paste disable

export const disablePaste = (event) => {
  if (developmentFlag) return;
  if ((event.ctrlKey || event.metaKey) && (event.key === 'v' || event.key === 'V')) {
    event.preventDefault();
  }
};

export const disableCopy = (event) => {
  if (developmentFlag) return;
  event.preventDefault();
};

export const deepClone = (src, refs = new WeakMap()) => {
  if (typeof src !== 'object' || src === null) {
    return src;
  }
  if (refs.has(src)) {
    return refs.get(src);
  }
  var result;
  if (Array.isArray(src)) {
    result = [];
    refs.set(src, result);
    src.forEach(function (d) {
      result.push(deepClone(d, refs));
    });
  } else if (src instanceof Date) {
    result = new Date(src.getTime());
    refs.set(src, result);
  } else if (src instanceof Node) {
    result = src.cloneNode(true);
    refs.set(src, result);
  } else if (
    src instanceof String ||
    src instanceof Boolean ||
    src instanceof Number
  ) {
    let Ctor = Object.getPrototypeOf(src).constructor;
    result = new Ctor(src);
    refs.set(src, result);
  } else {
    let Ctor = Object.getPrototypeOf(src).constructor;
    result = new Ctor();
    refs.set(src, result);
    Object.setPrototypeOf(result, Object.getPrototypeOf(src));
    var props = Object.getOwnPropertyNames(src);
    for (var i = 0, dtor, len = props.length; i < len; i++) {
      dtor = Object.getOwnPropertyDescriptor(src, props[i]);
      if ('value' in dtor) {
        dtor.value = deepClone(dtor.value, refs);
      }
      Object.defineProperty(result, props[i], dtor);
    }
  }
  return result;
};